export class CandidatureFormationOrder {
    // noinspection JSUnusedGlobalSymbols
    constructor(
        public id?: number,
        public ordre?: number,
        public ordreModifiable?: boolean
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature-formation-order.model.ts